import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
} from "~utils/moduleIntegrity";

import type { LineupContentArchiveProps } from "./LineupContentArchive";

export default function integrityCheck({
    items,
}: LineupContentArchiveProps): IntegrityStatus {
    return checkItemArrayIntegrity(items);
}
